import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IFacilitySeqReq, IGetFacilities, IGetFacilityCategories } from '../models/homepageManagementFacility.model';

const uri = '/mgmt/homepage-management/facility';

export const getFacilityCategories = (campusCode: string): AxiosPromise<IGetFacilityCategories> => {
  return axios.get(`${uri}/${campusCode}`);
};

export const getFacilities = (campusCode: string, facilityGbn: string): AxiosPromise<IGetFacilities> => {
  return axios.get(`${uri}/${campusCode}/${facilityGbn}`);
};

export const createFacility = (campusCode: string, data: FormData): AxiosPromise => {
  return axios.post(`${uri}/${campusCode}`, data);
};

export const updateFacilitySeq = (campusCode: string, facilityGbn: string, data: IFacilitySeqReq[]): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}/${facilityGbn}`, data);
};

export const deleteFacility = (campusCode: string, campusFacilityCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${campusCode}/${campusFacilityCode}`);
};
